import { useState } from "react";
import { evidenceBoard } from "@/mocks/home";

const statusStyle: Record<string, string> = {
  已核对: "bg-accent-100 text-accent-900 border-accent-300",
  待验证: "bg-secondary-100 text-secondary-900 border-secondary-300",
  存在差异: "bg-primary-100 text-primary-800 border-primary-300",
};

export default function EvidenceBoard() {
  const [filter, setFilter] = useState("全部");
  const filters = ["全部", "已核对", "待验证", "存在差异"];
  const list =
    filter === "全部" ? evidenceBoard : evidenceBoard.filter((item) => item.status === filter);

  return (
    <section id="evidence" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4 border-b border-background-200 pb-5">
          <div>
            <span className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.24em] text-primary-600">
              <i className="ri-folder-shield-2-line text-sm" />
              Evidence
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              证据汇总看板
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-7 text-foreground-600">
              每条材料都保留来源与核验状态，而不是直接给结论。状态标签说明它当前能支撑到什么程度。
            </p>
          </div>
          <div className="flex items-center gap-1 rounded-full border border-background-300 bg-background-50 px-1 py-1">
            {filters.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => setFilter(item)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs transition-colors ${
                  filter === item
                    ? "bg-primary-500 font-medium text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((item) => (
            <article
              key={item.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-start justify-between gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <span
                  className={`rounded border px-2 py-0.5 text-[11px] font-medium ${
                    statusStyle[item.status] ?? "border-background-300 text-foreground-600"
                  }`}
                >
                  {item.status}
                </span>
              </div>
              <span className="mt-4 text-[11px] font-medium uppercase tracking-wider text-secondary-600">
                {item.type}
              </span>
              <h3 className="mt-1 font-heading text-[15px] font-bold leading-snug text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-[13px] leading-6 text-foreground-600">{item.note}</p>
              <div className="mt-auto flex items-center gap-2 border-t border-background-200 pt-3 text-[11px] text-foreground-500">
                <i className="ri-links-line text-sm text-secondary-500" />
                {item.source}
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 flex items-center gap-2 text-xs text-foreground-500">
          <i className="ri-error-warning-line text-sm text-accent-600" />
          备注：本看板仅呈现材料本身与核验状态，不对事件当事人作出任何定性判断。
        </p>
      </div>
    </section>
  );
}